import { render, staticRenderFns } from "./BaseShowImage.vue?vue&type=template&id=45867677&"
import script from "./BaseShowImage.vue?vue&type=script&lang=js&"
export * from "./BaseShowImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports